// outros-resources-04 — tradução gerada a partir de scripts/i18n/out/missing-es.json
const catalogo: Record<string, string> = {
    "(ex: AppIconPro.appiconset)": "(ej: AppIconPro.appiconset)",
    "(ex: ic_launcher_pro.png)": "(ej: ic_launcher_pro.png)",
    "* As campanhas criadas e iniciadas HOJE serão enviadas a partir do dia seguinte.": "* Las campañas creadas e iniciadas HOY se enviarán a partir del día siguiente.",
    "* Quaisquer alterações realizadas estarão valendo apenas a partir do dia seguinte.": "* Cualquier cambio realizado será válido solo a partir del día siguiente.",
    "*A campanha não terá uma data de término.": "*La campaña no tendrá una fecha de finalización.",
    ". Sem este cadastro o cliente até consegue carregar, mas não pontua.": ". Sin este registro el cliente incluso puede cargar, pero no suma puntos.",
    "Adicionar Restantes": "Agregar restantes",
    "Ajuste": "Ajuste",
    "Ajuste de produtos realizado com sucesso": "Ajuste de productos realizado con éxito",
    "Android: O arquivo deve ser": "Android: El archivo debe ser",
    "Aparece no app e no cupom. Ex.: Vale 10 reais": "Aparece en la aplicación y en el cupón. Ej.: Vale 10 reales",
    "Apenas para usuário Admin": "Solo para usuario Admin",
    "AppIcon{Nome}.appiconset": "AppIcon{Nome}.appiconset",
    "Aprovar": "Aprobar",
    "Aprovar pontos pendentes": "Aprobar puntos pendientes",
    "Após criar os assets:": "Después de crear los assets:",
    "Assunto": "Asunto",
    "Atualizado com sucesso.": "Actualizado con éxito.",
    "Buscando postos": "Buscando estaciones",
    "Cadastrar Novo Parceiro Externo": "Registrar nuevo socio externo",
    "Cadastrar Plano": "Registrar plan",
    "Cadastrar carregador": "Registrar cargador",
    "Cadastrar nova permissão": "Registrar nuevo permiso",
    "Cadastrar novo grupo de permissões": "Registrar nuevo grupo de permisos",
    "Cadastrar produto em dinheiro": "Registrar producto en dinero",
    "Campanhas de marketing": "Campañas de marketing",
    "Carregadores elétricos": "Cargadores eléctricos",
    "Cliente restaurado com sucesso!": "¡Cliente restaurado con éxito!",
    "Como configurar ícones alternativos do app": "Cómo configurar íconos alternativos de la aplicación",
    "Concluído": "Completado",
    "Confirmar Nova Senha": "Confirmar nueva contraseña",
    "Criado em:": "Creado en:",
    "Criar Novidade": "Crear novedad",
    "Criar campanha de marketing": "Crear campaña de marketing",
    "Código do QR": "Código del QR",
    "Dados Gerais": "Datos generales",
    "Data da transferência": "Fecha de la transferencia",
    "Data de Criação": "Fecha de creación",
    "Data de exclusão": "Fecha de eliminación",
    "Data do Pagamento": "Fecha del pago",
    "Data do ajuste": "Fecha del ajuste",
    "Deletado em": "Eliminado en",
    "Deletado por": "Eliminado por",
    "Deletar": "Eliminar",
    "Depósito Central": "Depósito Central",
    "Depósito de destino": "Depósito de destino",
    "Depósito de origem": "Depósito de origen",
    "Desligado, o carregador para de abrir sessão — o cliente carrega, mas não pontua.": "Desactivado, el cargador deja de abrir sesión — el cliente carga, pero no suma puntos.",
    "Detectado em": "Detectado en",
    "Detecção": "Detección",
    "Diferença Depósito": "Diferencia depósito",
    "Diferença Mostruário": "Diferencia exhibición",
    "Duração (dias)": "Duración (días)",
    "Editar Novidade": "Editar novedad",
    "Editar Parceiro Externo": "Editar socio externo",
    "Editar Plano": "Editar plan",
    "Editar campanha": "Editar campaña",
    "Editar carregador elétrico": "Editar cargador eléctrico",
    "Editar combustível": "Editar combustible",
    "Editar grupo de permissões": "Editar grupo de permisos",
    "Editar permissão": "Editar permiso",
    "Editar produto em dinheiro": "Editar producto en dinero",
    "Em branco usa o valor do produto": "En blanco usa el valor del producto",
    "Em homologação": "En homologación",
    "Encerrar campanha": "Finalizar campaña",
    "Erro ao deletar limite": "Error al eliminar límite",
    "Erro ao restaurar cliente": "Error al restaurar cliente",
    "Erro ao salvar ajuste de produtos": "Error al guardar ajuste de productos",
    "Erro ao salvar transferência de produtos": "Error al guardar transferencia de productos",
    "Essa mensagem pode conter formatações e será exibida no aplicativo, na tela de notificações. Ela NÃO será enviada na notificação PUSH": "Este mensaje puede contener formato y se mostrará en la aplicación, en la pantalla de notificaciones. NO se enviará en la notificación PUSH",
    "Estrutura de pastas necessária:": "Estructura de carpetas necesaria:",
    "Excluir parceiro externo": "Eliminar socio externo",
    "Expirado": "Expirado",
    "Falha no envio": "Falla en el envío",
    "Fim da campanha": "Fin de la campaña",
    "Gerando mapa": "Generando mapa",
    "Horário de Envio": "Horario de envío",
    "IP": "IP",
    "Identificador do ícone alternativo (ex: pro, gold, vip). Use 'default' para ícone padrão.": "Identificador del ícono alternativo (ej: pro, gold, vip). Use 'default' para ícono predeterminado.",
    "Identificação (opcional)": "Identificación (opcional)",
    "Imagem do produto": "Imagen del producto",
    "Imagem indisponível": "Imagen no disponible",
    "Importante:": "Importante:",
    "Inativar": "Desactivar",
    "Inativar produto em dinheiro": "Desactivar producto en dinero",
    "Informações básicas": "Información básica",
    "Início da campanha": "Inicio de la campaña",
    "Justificativa": "Justificación",
    "Limite de Número de Abastecimentos": "Límite de número de cargas de combustible",
    "Mantido por compatibilidade": "Mantenido por compatibilidad",
    "Menor número = maior prioridade. Quando usuário tem múltiplos planos, o de menor número prevalece.": "Menor número = mayor prioridad. Cuando el usuario tiene múltiples planes, el de menor número prevalece.",
    "Mostrar concluídos": "Mostrar completados",
    "Mostrar na tela inicial": "Mostrar en la pantalla de inicio",
    "Nenhum Ponto de Troca encontrado": "Ningún punto de canje encontrado",
    "Nenhum produto no inventário": "Ningún producto en el inventario",
    "Nenhuma cobrança associada": "Ningún cobro asociado",
    "Nome do Cliente": "Nombre del cliente",
    "Nome do Plano": "Nombre del plan",
    "Nome do Posto": "Nombre de la estación",
    "Nome do Ícone": "Nombre del ícono",
    "Notificado": "Notificado",
    "Nova regra de Limite de Número de Abastecimentos": "Nueva regla de límite de número de cargas de combustible",
    "Novidade": "Novedad",
    "Não": "No",
    "Não notificado": "No notificado",
    "O cliente resgata este produto por pontos e apresenta o cupom no caixa, que abate o valor em reais da compra. Deixe o nome em branco para preenchê-lo automaticamente com o valor.": "El cliente canjea este producto por puntos y presenta el cupón en la caja, que descuenta el valor en reales de la compra. Deje el nombre en blanco para completarlo automáticamente con el valor.",
    "O código do QR não pode ser alterado — ele identifica o carregador no sistema da InCharge. Se o adesivo mudou, remova este e cadastre o novo.": "El código del QR no se puede modificar — identifica el cargador en el sistema de InCharge. Si el adhesivo cambió, elimine este y registre el nuevo.",
    "O posto define quantos pontos o cliente ganha por kWh.": "La estación de servicio define cuántos puntos gana el cliente por kWh.",
    "O preview": "La vista previa",
    "O produto deixa de aparecer no app e nos resgates. Deseja continuar?": "El producto deja de aparecer en la aplicación y en los canjes. ¿Desea continuar?",
    "O script detecta automaticamente os ícones e configura o app.": "El script detecta automáticamente los íconos y configura la aplicación.",
    "Pagamento de Parceiro": "Pago de socio",
    "Para que o ícone alternativo funcione, é necessário criar os assets no repositório": "Para que el ícono alternativo funcione, es necesario crear los assets en el repositorio",
    "Periodo": "Período",
    "Permissões do grupo": "Permisos del grupo",
    "Planos": "Planes",
    "Ponto de troca": "Punto de canje",
    "Pontos reprovados com sucesso!": "¡Puntos rechazados con éxito!",
    "Pontos validados com sucesso!": "¡Puntos validados con éxito!",
    "Preencha apenas se quiser alterar a senha": "Complete solo si desea cambiar la contraseña",
    "Qtd. Cobranças": "Cant. cobros",
    "Quantidade Atual": "Cantidad actual",
    "Quantidade Final": "Cantidad final",
    "Quantidade Transferida": "Cantidad transferida",
    "Quantidade de Abastecimentos": "Cantidad de cargas de combustible",
    "Quantidade de abastecimentos": "Cantidad de cargas de combustible",
    "Quantidade de dias": "Cantidad de días",
    "Quantidade de dias que o plano fica ativo após o usuário entrar": "Cantidad de días que el plan permanece activo después de que el usuario ingresa",
    "Quantidade em Depósito": "Cantidad en depósito",
    "Quantidade em Mostruário": "Cantidad en exhibición",
    "Recomendamos que essas informações estejam presentes no regulamento do programa de fidelidade do posto": "Recomendamos que esta información esté presente en el reglamento del programa de fidelidad de la estación de servicio",
    "Reprovar": "Rechazar",
    "Resolvida": "Resuelta",
    "Resolvido": "Resuelto",
    "Resolvidos": "Resueltos",
    "Responder (WhatsApp)": "Responder (WhatsApp)",
    "SD010": "SD010",
    "Saldo (antes → depois)": "Saldo (antes → después)",
    "Saldo negativo": "Saldo negativo",
    "Sem Assunto": "Sin asunto",
    "Sempre ativa": "Siempre activa",
    "Senha (deixe em branco para não alterar)": "Contraseña (deje en blanco para no cambiar)",
    "Sim": "Sí",
    "Só letras, números e hífen. Não pode repetir.": "Solo letras, números y guion. No puede repetirse.",
    "Só para você se achar na lista. Ex.: \"Carregador 1 - entrada\".": "Solo para que usted se ubique en la lista. Ej.: \"Cargador 1 - entrada\".",
    "Todos os Postos": "Todas las estaciones",
    "Token (Deprecated)": "Token (Deprecated)",
    "Transação": "Transacción",
    "Transferência de produtos realizada com sucesso": "Transferencia de productos realizada con éxito",
    "Unidade": "Unidad",
    "Unidade de destino": "Unidad de destino",
    "Unidade de origem": "Unidad de origen",
    "Use \"default\" se não quiser ícone alternativo (ícone padrão da rede)": "Use \"default\" si no desea un ícono alternativo (ícono predeterminado de la red)",
    "Valor Parceiro": "Valor del socio",
    "Valor Total": "Valor total",
    "Valor padrão em pontos": "Valor predeterminado en puntos",
    "Visualizar Comprovante": "Ver comprobante",
    "antes de rodar o wl-script.": "antes de ejecutar el wl-script.",
    "deve ser em minúsculo e sem espaços (ex: pro, gold, vip, premium)": "debe estar en minúsculas y sin espacios (ej: pro, gold, vip, premium)",
    "fechar": "cerrar",
    "iOS: A pasta deve ser": "iOS: La carpeta debe ser",
    "ic_launcher_{nome}.png": "ic_launcher_{nome}.png",
    "icon-preview-{nome}.png": "icon-preview-{nome}.png",
    "nome do ícone": "nombre del ícono",
    "npm run wl-script {rede}": "npm run wl-script {rede}",
    "wl-src/{rede}/": "wl-src/{rede}/",
    "Ícone": "Ícono",
    "Último aviso": "Último aviso",
    "é exibido no modal de celebração do app": "se muestra en el modal de celebración de la aplicación",
    "‚ o código é": ", el código es",
};

export default catalogo;
